import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "test") {
      return;
    }

    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      // JSDOM does not implement window.scrollTo.
    }
  }, [pathname]);

  return null;
}
